import { useLocation } from 'react-router-dom';
import './Intro.css';

type Props = {
    title: string;
    subtitle?: string;
    titleColorSubtitle?: string;
    description?: string;
    titleColor?: string;
};

const splitTitle = (title: string) => {
    const firstSpaceIndex = title.indexOf(' ');
    return {
        councilType: title.substring(0, firstSpaceIndex),
        councilName: title.substring(firstSpaceIndex + 1)
    };
};

// Intro section of each page, containing main title, subtitle and description.
const Intro = ({ title, subtitle, titleColorSubtitle, description, titleColor }: Props) => {
    const { pathname } = useLocation();
    const isRootPath = pathname === '/';
    const { councilType, councilName } = splitTitle(title);

    return (
        <section className='intro'>
            <h1 style={{ color: titleColor }}>
                {isRootPath ? (
                    <>
                        {councilType}
                        <br />
                        {councilName}
                    </>
                ) : (
                    title
                )}
            </h1>
            {subtitle && <h2>{subtitle}</h2>}
            {titleColorSubtitle && (
                <h2
                    style={{
                        color: titleColor
                    }}
                >
                    {titleColorSubtitle}
                </h2>
            )}
            {description && <p className='description-text'>{description}</p>}
        </section>
    );
};

export default Intro;
